import React, { FC } from 'react';
import _noop from 'lodash/noop';
import cls from 'classnames';
import { l10nhtml } from '@ott/l10n';

import useEmailSubscriptionForm from '../../hooks/useEmailSubscriptionForm';
import { CommonProps } from '../../types';
import { defaultTexts } from '../../constants';
import SubscriptionForm from './blocks/SubscriptionForm';
import styles from './EmailSubscriptionBanner.scss';

type Props = CommonProps & {
  /** Всегда показываем в кнопке отправки стрелку вместо текста */
  alwaysShowMobileView?: boolean;
};

const EmailSubscriptionBanner: FC<Props> = ({
  alwaysShowMobileView = false,
  auth,
  className,
  metrics,
  onSuccess = _noop,
  texts = defaultTexts,
}) => {
  const formProps = useEmailSubscriptionForm({ auth, onSuccess, metrics });
  const { isSuccess, isHidden } = formProps;

  const isAuth = Boolean(auth?.data?.auth);

  if (!isSuccess && isHidden) {
    return null;
  }

  return (
    <div className={cls(styles.container, className)} data-locator="subscription-banner">
      <div className={styles.banner}>
        <div className={styles.content}>
          <div className={styles.title}>{texts?.title}</div>
          <div className={styles.description}>{texts?.description}</div>
        </div>

        <SubscriptionForm
          className={styles.form}
          alwaysShowMobileView={alwaysShowMobileView}
          {...formProps}
        />
      </div>
      {!isAuth && (
        <div className={styles.details} data-locator="details">
          {l10nhtml('emailSubscription.content.details')}
        </div>
      )}
    </div>
  );
};

export default EmailSubscriptionBanner;
